export enum EOrderStatus {
	ACTIVE = 'active',
	CANCELLED = 'cancelled',
	ON_HOLD = 'on_hold',
	NOT_CONFIRMED = 'not_confirmed',
	FINISHED = 'finished',
}

export const orderStatusMap: { [key in EOrderStatus]: string } = {
	[EOrderStatus.ACTIVE]: 'Aktywna',
	[EOrderStatus.CANCELLED]: 'Anulowana',
	[EOrderStatus.ON_HOLD]: 'Wstrzymana',
	[EOrderStatus.NOT_CONFIRMED]: 'Niepotwierdzona',
	[EOrderStatus.FINISHED]: 'Zakończona',
}

export const orderStatuses = generateSelectOptions(EOrderStatus, orderStatusMap)

export enum EOrderSource {
	MOBILE = 'mobile_app',
	CRM = 'crm',
	WWW = 'www_form',
	CLIENT = 'client_panel',
}

export const orderSourceMap: { [key in EOrderSource]: string } = {
	[EOrderSource.MOBILE]: 'Aplikacja mobilna',
	[EOrderSource.CRM]: 'CRM',
	[EOrderSource.WWW]: 'Formularz www',
	[EOrderSource.CLIENT]: 'Panel klienta',
}

export const orderSources = generateSelectOptions(EOrderSource, orderSourceMap)

export enum EOrderDietType {
	STANDARD = 'standard',
	MENU_SELECTION = 'menu_selection',
}

export const orderDietTypeMap: { [key in EOrderDietType]: string } = {
	[EOrderDietType.STANDARD]: 'Gotowe diety',
	[EOrderDietType.MENU_SELECTION]: 'Wybór menu',
}

export const orderDietTypes = generateSelectOptions(EOrderDietType, orderDietTypeMap)

export enum EOrderCartStatus {
	CART = 'cart',
	PLACED = 'placed',
	PAID = 'paid',
	CANCELLED = 'cancelled',
	DRAFT = 'draft',
	FREE = 'free',
}

export const orderCartStatusMap: { [key in EOrderCartStatus]: string } = {
	[EOrderCartStatus.CART]: 'Koszyk',
	[EOrderCartStatus.PLACED]: 'Do opłacenia',
	[EOrderCartStatus.PAID]: 'Opłacone',
	[EOrderCartStatus.CANCELLED]: 'Anulowane',
	[EOrderCartStatus.DRAFT]: 'Draft',
	[EOrderCartStatus.FREE]: 'Za darmo',
}

export const orderCartStatusDescriptionMap: Partial<Record<EOrderCartStatus, string>> = {
	[EOrderCartStatus.PLACED]: 'Zamówienie złożone – do opłacenia przez klienta w panelu klienta',
	[EOrderCartStatus.PAID]: 'Klient już opłacił własnymi środkami.',
	[EOrderCartStatus.FREE]: 'Zamówienie bez opłaty.',
}

export const orderCartStatuses = generateSelectOptions(EOrderCartStatus, orderCartStatusMap)

export enum ECartSource {
	CRM = 'crm',
	WEB = 'web',
	IOS = 'ios',
	ANDROID = 'android',
}

export const cartSourceMap: { [key in ECartSource]: string } = {
	[ECartSource.IOS]: 'iOS',
	[ECartSource.CRM]: 'CRM',
	[ECartSource.WEB]: 'Panel klienta',
	[ECartSource.ANDROID]: 'Android',
}

export const cartSources = generateSelectOptions(ECartSource, cartSourceMap)

export enum EClientDietStatus {
	ACTIVE = 'active',
	FINISHED = 'finished',
	CANCELLED = 'cancelled',
}

export const clientDietStatusMap: { [key in EClientDietStatus]: string } = {
	[EClientDietStatus.ACTIVE]: 'Aktywna',
	[EClientDietStatus.FINISHED]: 'Zakończona',
	[EClientDietStatus.CANCELLED]: 'Anulowana',
}

export const clientDietStatus = generateSelectOptions(EClientDietStatus, clientDietStatusMap)

export enum EOrderSelectionSource {
	AI = 'ai',
	CLIENT = 'client',
	EMPLOYEE = 'employee',
	DEFAULT = 'default',
}

export enum ERefundType {
	VOUCHER = 'voucher',
	NONE = 'none',
	MANUAL = 'manual',
}

export const refundTypeMap: { [key in ERefundType]: string } = {
	[ERefundType.VOUCHER]: 'Voucher',
	[ERefundType.NONE]: 'Brak zwrotu',
	[ERefundType.MANUAL]: 'Manualny (ręczne rozliczenie poza systemem)',
}

export const refundTypes = generateSelectOptions(ERefundType, refundTypeMap)

export enum ECartMainItemType {
	DIET = 'diet',
	DIET_EXTENSION = 'diet_extension',
	ADDON = 'addon',
}

export enum ECartItemType {
	PRODUCT = 'product', // points
	DIET_CHANGE = 'diet_change',
	DIET_EXTENSION = 'diet_extension',
	ADDON = 'addon',

	DIET = 'diet',
	MEAL_CHANGE = 'meal_change',
	EXTRA_MEAL = 'extra_meal',
	MEAL_SLOTS_CONFIG_CHANGE = 'meal_slots_config_change',
}
